import { render } from "./top-right.vue?vue&type=template&id=c6de8cea&lang=pug"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__